module.exports = __webpack_public_path__ + "line-awesome.3f85d8035b4ccd91d2a1.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/assets/vendors/line-awesome/fonts/line-awesome.eot?v=1.1.
// module id = ../../../../../src/assets/vendors/line-awesome/fonts/line-awesome.eot?v=1.1.
// module chunks = styles